module.exports = __webpack_public_path__ + "img/tab_button_img1_mobile.15192c16.png";